import { render, staticRenderFns } from "./Software.vue?vue&type=template&id=26582f70"
import script from "./Software.vue?vue&type=script&lang=js"
export * from "./Software.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports